import img1 from './img/blog-img-01.jpg'
import img2 from './img/blog-img-02.jpg'
import img3 from './img/blog-img-03.jpg'
import img4 from './img/blog-img-04.jpg'

export const images = [
  {
    link: 'http://localhost:3005/home',
    img: img1,
    text: 'Texto descriptivo para la imagen'
  },
  {
    link: 'http://localhost:3005/home',
    img: img2,
    text: 'Texto descriptivo para la imagen'
  },
  {
    link: 'http://localhost:3005/home',
    img: img3,
    text: 'Texto descriptivo para la imagen'
  },
  {
    link: 'http://localhost:3005/home',
    img: img4,
    text: 'Texto descriptivo para la imagen'
  }
]
